import { render, staticRenderFns } from "./ViewCategories.vue?vue&type=template&id=d282e4a8&scoped=true"
import script from "./ViewCategories.vue?vue&type=script&lang=js"
export * from "./ViewCategories.vue?vue&type=script&lang=js"
import style0 from "./ViewCategories.vue?vue&type=style&index=0&id=d282e4a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d282e4a8",
  null
  
)

export default component.exports